export interface OutdoorDetails {
  difficulty: 'easy' | 'moderate' | 'strenuous'
  distance: string
  elevation: string
  meetupNote: string
}

interface Props extends OutdoorDetails {
  setDifficulty: (v: 'easy' | 'moderate' | 'strenuous') => void
  setDistance: (v: string) => void
  setElevation: (v: string) => void
  setMeetupNote: (v: string) => void
}

export function OutdoorDetailsFields({
  difficulty, setDifficulty,
  distance, setDistance,
  elevation, setElevation,
  meetupNote, setMeetupNote,
}: Props) {
  return (
    <div className="flex flex-col gap-3.5">
      <div>
        <div className="text-[12.5px] font-semibold text-ink-2 mb-2">Difficulty</div>
        <div className="flex gap-2">
          {(['easy', 'moderate', 'strenuous'] as const).map((d) => (
            <button
              key={d}
              type="button"
              onClick={() => setDifficulty(d)}
              aria-pressed={difficulty === d}
              className={`flex-1 h-10 rounded-[10px] border-0 cursor-pointer font-sans text-[13px] font-medium capitalize ${
                difficulty === d
                  ? 'bg-primary text-on-primary'
                  : 'bg-s2 text-ink-2 shadow-[0_0_0_1px_var(--line-soft)]'
              }`}
            >
              {d}
            </button>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <label className="flex flex-col gap-1.5">
          <span className="text-[12.5px] font-semibold text-ink-2">Distance (miles)</span>
          <input
            id="outdoorDistance"
            type="number"
            min={0}
            step={0.1}
            value={distance}
            onChange={(e) => setDistance(e.target.value)}
            placeholder="e.g. 4.5"
            className="input"
            aria-label="Distance (miles)"
          />
        </label>
        <label className="flex flex-col gap-1.5">
          <span className="text-[12.5px] font-semibold text-ink-2">Elevation gain (ft)</span>
          <input
            id="outdoorElevation"
            type="number"
            min={0}
            value={elevation}
            onChange={(e) => setElevation(e.target.value)}
            placeholder="e.g. 800"
            className="input"
            aria-label="Elevation gain (ft)"
          />
        </label>
      </div>
      <label className="flex flex-col gap-1.5">
        <span className="text-[12.5px] font-semibold text-ink-2">Meetup note</span>
        <input
          id="outdoorMeetupNote"
          type="text"
          value={meetupNote}
          onChange={(e) => setMeetupNote(e.target.value)}
          placeholder="Meet at the trailhead parking lot"
          className="input"
          aria-label="Meetup note"
        />
      </label>
    </div>
  )
}
